// 课程订单列表
const CourseOrderTable = () => import('@pv/orderCenter/order/orderTable');
// 课程订单详情
const CourseOrderDetail = () => import('@pv/orderCenter/order/orderDetail');

// 课程套餐订单列表
const CourseComboOrderTable = () => import('@pv/orderCenter/Combo/Index');
// 课程套餐订单详情
const CourseComboOrderDetail = () => import('@pv/orderCenter/Combo/Detail');

// 课程退款(学校)
const SchCourseRefund = () =>
  import('@pv/orderCenter/theAfterSale/SchCourseRefund');
// 批量退款 管理首页
const BatchRefundIndex = () =>
  import('@pv/orderCenter/theAfterSale/BatchRefundIndex');
// 批量退款
const batchRefundEdit = () =>
  import('@pv/orderCenter/theAfterSale/BatchRefundEdit');

// 订单中心-财务管理-结算账单(机构)
const OrgSettlement = () => import('@pv/orderCenter/finance/OrgSettlement');
// 订单中心-财务管理-结算账单-机构结算单详情 - 订单明细
const OrgSettlementList = () =>
  import('@pv/orderCenter/finance/OrgSettlementList');

// 订单中心-财务管理-结算账单(学校)
const SchSettlement = () => import('@pv/orderCenter/finance/OrgSettlement');

// 订单中心-财务管理-结算账单(教育局)
const EduSettlement = () => import('@pv/orderCenter/finance/OrgSettlement');
// 订单中心-财务管理-结算账单-详情(机构)
const OrgSettlementDetails = () =>
  import('@pv/orderCenter/finance/OrgSettlementDetails');
// 订单中心-财务管理-结算账单-详情(学校)
const SchSettlementDetails = () =>
  import('@pv/orderCenter/finance/OrgSettlementDetails');
// 订单中心-财务管理-结算账单-详情(教育局)
const EduSettlementDetails = () =>
  import('@pv/orderCenter/finance/OrgSettlementDetails');
// 订单中心-财务管理-结算账单-机构结算单详情(教育局)
const OrgSettlementEduDetails = () =>
  import('@pv/orderCenter/finance/OrgSettlementEduDetails');

// 订单中心-财务管理-审批流程
const CheckFlow = () => import('@pv/orderCenter/finance/CheckFlow');

// 运营端 - 分账
const ProfitSharingIndex = () => import('@pv/orderCenter/profitSharing/Index');
// 运营端 - 机构分账配置记录
const ProfitSharingNotesList = () =>
  import('@pv/orderCenter/profitSharing/NotesList');
// 运营端 - 添加&编辑 分账规则
const ProfitSharingEdit = () => import('@pv/orderCenter/profitSharing/Edit');

// 运营端 - 详情 分账规则
const ProfitSharingDetails = () =>
  import('@pv/orderCenter/profitSharing/Details');

// 运营端 - 配置机构 分账规则
const ProfitSharingDeployOrg = () =>
  import('@pv/orderCenter/profitSharing/DeployOrg');
// 运营端 - 配置学校 分账规则
const ProfitSharingDeploySch = () =>
  import('@pv/orderCenter/profitSharing/DeploySch');
// 运营端 - 订单管理 材料费订单
const MaterialIndex = () => import('@pv/orderCenter/order/material/Index.vue');
// 导入订单
const ImportOrder = () => import('@pv/orderCenter/order/ImportOrder.vue');

// 退款申请单列表
const RefundApplicationList = () =>
  import('@pv/orderCenter/theAfterSale/RefundApplicationList');

// 退款申请单
const RefundApplicationAdd = () =>
  import('@pv/orderCenter/theAfterSale/RefundApplicationAdd');

const RefundApplicationDetails = () => import('@pv/orderCenter/theAfterSale/RefundApplicationDetails');

const RefundApplicationOrderList = () => import('@pv/orderCenter/theAfterSale/RefundApplicationOrderList');

export default [
  {
    path: '/orderCenter/order/orderTable',
    name: 'orderCenter_order_orderTable',
    meta: {
      title: '课程订单',
      activePath: '/orderCenter/order/orderTable',
      breadcrumb: '订单中心-订单管理-课程订单'
    },
    component: CourseOrderTable
  },
  {
    path: '/orderCenter/order/orderTable/importOrder',
    name: 'orderCenter_order_importOrder',
    meta: {
      title: '导入订单',
      activePath: '/orderCenter/order/orderTable',
      breadcrumb: '订单中心-订单管理-课程订单-导入订单'
    },
    component: ImportOrder
  },
  {
    path: '/orderCenter/order/orderTable/orderDetail',
    name: 'orderCenter_order_orderTable_orderDetail',
    meta: {
      title: '课程订单详情',
      activePath: '/orderCenter/order/orderTable',
      breadcrumb: '订单中心-订单管理-课程订单-课程订单详情'
    },
    component: CourseOrderDetail
  },
  {
    path: '/orderCenter/order/comboIndex',
    name: 'orderCenter_order_comboIndex',
    meta: {
      title: '课程订单',
      activePath: '/orderCenter/order/comboIndex',
      breadcrumb: '订单中心-订单管理-课程套餐订单'
    },
    component: CourseComboOrderTable
  },
  {
    path: '/orderCenter/order/comboIndex/detail',
    name: 'orderCenter_order_comboIndex_detail',
    meta: {
      title: '课程订单',
      activePath: '/orderCenter/order/comboIndex',
      breadcrumb: '订单中心-订单管理-课程套餐订单-套餐订单详情'
    },
    component: CourseComboOrderDetail
  },

  // 学校课程退款 && 运营端课程退款
  {
    path: '/orderCenter/afterSale/schCourseRefund',
    name: 'orderCenter_afterSale_schCourseRefund',
    meta: {
      title: '课程退款',
      activePath: '/orderCenter/afterSale/schCourseRefund',
      breadcrumb: '订单中心-售后管理-课程退款'
    },
    component: SchCourseRefund
  },

  {
    path: '/orderCenter/afterSale/batchRefundIndex',
    name: 'orderCenter_afterSale_batchRefundIndex',
    meta: {
      title: '课程批量退款',
      activePath: '/orderCenter/afterSale/batchRefundIndex',
      breadcrumb: '订单中心-售后管理-课程批量退款'
    },
    component: BatchRefundIndex
  },
  // 批量退款
  {
    path: '/orderCenter/afterSale/batchRefundIndex/batchRefundEdit',
    name: 'orderCenter_afterSale_batchRefundIndex_batchRefundEdit',
    meta: {
      title: '发起批量退款',
      activePath: '/orderCenter/afterSale/batchRefundIndex',
      breadcrumb: '订单中心-售后管理-课程批量退款-发起批量退款'
    },
    component: batchRefundEdit
  },
  // 机构端-财务管理-订单修改记录

  {
    path: '/orderCenter/finance/SchSettlement',
    name: 'orderCenter_finance_SchSettlement',
    meta: {
      title: '结算账单(学校)',
      tableType: 2,
      activePath: '/orderCenter/finance/SchSettlement',
      breadcrumb: '订单中心-财务管理-结算账单(学校)'
    },
    component: SchSettlement
  },
  {
    path: '/orderCenter/finance/SchSettlement/details',
    name: 'orderCenter_finance_SchSettlement_details',
    meta: {
      title: '结算单详情',
      tableType: 2,
      activePath: '/orderCenter/finance/SchSettlement',
      breadcrumb: '订单中心-财务管理-结算账单（学校）-结算单详情'
    },
    component: SchSettlementDetails
  },
  {
    path: '/orderCenter/finance/schSettlement/details/list',
    name: 'orderCenter_finance_SchSettlement_details_list',
    meta: {
      title: '订单明细',
      tableType: 1,
      activePath: '/orderCenter/finance/SchSettlement',
      breadcrumb: '订单中心-财务管理-结算账单(学校)-结算账单详情-订单明细'
    },
    component: OrgSettlementList
  },
  {
    path: '/orderCenter/finance/OrgSettlement',
    name: 'orderCenter_finance_OrgSettlement',
    meta: {
      title: '结算账单(机构)',
      tableType: 1,
      activePath: '/orderCenter/finance/OrgSettlement',
      breadcrumb: '订单中心-财务管理-结算账单(机构)'
    },
    component: OrgSettlement
  },

  {
    path: '/orderCenter/finance/OrgSettlement/details',
    name: 'orderCenter_finance_OrgSettlement_details',
    meta: {
      title: '结算单详情',
      tableType: 1,
      activePath: '/orderCenter/finance/OrgSettlement',
      breadcrumb: '订单中心-财务管理-结算账单（机构）-结算单详情'
    },
    component: OrgSettlementDetails
  },
  {
    path: '/orderCenter/finance/OrgSettlement/details/list',
    name: 'orderCenter_finance_OrgSettlement_details_list',
    meta: {
      title: '订单明细',
      tableType: 1,
      activePath: '/orderCenter/finance/OrgSettlement',
      breadcrumb: '订单中心-财务管理-结算账单(机构)-结算账单详情-订单明细'
    },
    component: OrgSettlementList
  },

  {
    path: '/orderCenter/finance/EduSettlement',
    name: 'orderCenter_finance_EduSettlement',
    meta: {
      title: '结算账单(教育局)',
      tableType: 3,
      activePath: '/orderCenter/finance/EduSettlement',
      breadcrumb: '订单中心-售后服务-结算账单(教育局)'
    },
    component: EduSettlement
  },
  {
    path: '/orderCenter/finance/EduSettlement/details',
    name: 'orderCenter_finance_EduSettlement_details',
    meta: {
      title: '结算单详情',
      tableType: 3,
      activePath: '/orderCenter/finance/EduSettlement',
      breadcrumb: '订单中心-财务管理-结算账单（教育局）-结算单详情'
    },
    component: EduSettlementDetails
  },

  {
    path: '/orderCenter/finance/EduSettlement/orgdetails',
    name: 'orderCenter_finance_EduSettlement_orgdetails',
    meta: {
      title: '结算单详情',
      tableType: 1,
      activePath: '/orderCenter/finance/EduSettlement',
      breadcrumb: '订单中心-财务管理-结算账单（教育局）-结算账单详情'
    },
    component: OrgSettlementEduDetails
  },

  {
    path: '/orderCenter/finance/EduSettlement/checkFlow',
    name: 'orderCenter_finance_EduSettlement_checkFlow',
    meta: {
      title: '配置结算审批流程',
      tableType: 3,
      activePath: '/orderCenter/finance/EduSettlement',
      breadcrumb: '订单中心-财务管理-结算账单（教育局）-配置结算审批流程'
    },
    component: CheckFlow
  },
  {
    path: '/orderCenter/profitSharing/index',
    name: 'orderCenter_profitSharing_index',
    meta: {
      title: '修改记录',
      activePath: '/orderCenter/profitSharing/index',
      breadcrumb: '订单中心-分账-分账规则'
    },
    component: ProfitSharingIndex
  },
  {
    path: '/orderCenter/profitSharing/notesList',
    name: 'orderCenter_profitSharing_notesList',
    meta: {
      title: '修改记录',
      activePath: '/orderCenter/profitSharing/notesList',
      breadcrumb: '订单中心-分账-机构分账配置记录'
    },
    component: ProfitSharingNotesList
  },
  {
    path: '/orderCenter/profitSharing/index/add',
    name: 'orderCenter_profitSharing_index_add',
    meta: {
      title: '修改记录',
      activePath: '/orderCenter/profitSharing/index',
      breadcrumb: '订单中心-分账-分账规则-新增分账规则'
    },
    component: ProfitSharingEdit
  },
  {
    path: '/orderCenter/profitSharing/index/edit',
    name: 'orderCenter_profitSharing_index_edit',
    meta: {
      title: '修改记录',
      activePath: '/orderCenter/profitSharing/index',
      breadcrumb: '订单中心-分账-分账规则-编辑分账规则'
    },
    component: ProfitSharingEdit
  },
  {
    path: '/orderCenter/profitSharing/index/details',
    name: 'orderCenter_profitSharing_index_details',
    meta: {
      title: '修改记录',
      activePath: '/orderCenter/profitSharing/index',
      breadcrumb: '订单中心-分账-分账规则-分账规则详情'
    },
    component: ProfitSharingDetails
  },
  {
    path: '/orderCenter/profitSharing/index/deployOrg',
    name: 'orderCenter_profitSharing_index_deployOrg',
    meta: {
      title: '修改记录',
      activePath: '/orderCenter/profitSharing/index',
      breadcrumb: '订单中心-分账-分账规则-配置机构'
    },
    component: ProfitSharingDeployOrg
  },
  {
    path: '/orderCenter/profitSharing/index/deploySch',
    name: 'orderCenter_profitSharing_index_deploySch',
    meta: {
      title: '修改记录',
      activePath: '/orderCenter/profitSharing/index',
      breadcrumb: '订单中心-分账-分账规则-配置学校'
    },
    component: ProfitSharingDeploySch
  },
  {
    path: '/orderCenter/order/materialIndex',
    name: 'orderCenter_order_materialIndex',
    meta: {
      title: '课程订单',
      activePath: '/orderCenter/order/materialIndex',
      breadcrumb: '订单中心-订单管理-材料费订单'
    },
    component: MaterialIndex
  },
  {
    path: '/orderCenter/afterSale/refundApplicationList',
    name: 'orderCenter_afterSale_refundApplicationList',
    meta: {
      title: '退款申请单',
      activePath: '/orderCenter/afterSale/refundApplicationList',
      breadcrumb: '订单中心-售后管理-退款申请单'
    },
    component: RefundApplicationList
  },
  {
    path: '/orderCenter/afterSale/refundApplicationList/refundApplicationAdd',
    name: 'orderCenter_afterSale_refundApplicationList_refundApplicationAdd',
    meta: {
      title: '创建退款申请单',
      activePath: '/orderCenter/afterSale/refundApplicationList',
      breadcrumb: '订单中心-售后管理-退款申请单-创建退款申请单'
    },
    component: RefundApplicationAdd
  },
  {
    path: '/orderCenter/afterSale/refundApplicationList/refundApplicationDetails',
    name: 'orderCenter_afterSale_refundApplicationList_refundApplicationDetails',
    meta: {
      title: '退款确认单',
      activePath: '/orderCenter/afterSale/refundApplicationList',
      breadcrumb: '订单中心-售后管理-退款申请单-退款确认单'
    },
    component: RefundApplicationDetails
  },
  {
    path: '/orderCenter/afterSale/refundApplicationList/refundApplicationOrderList',
    name: 'orderCenter_afterSale_refundApplicationList_refundApplicationOrderList',
    meta: {
      title: '退款确认单待退款明细',
      activePath: '/orderCenter/afterSale/refundApplicationList',
      breadcrumb: '订单中心-售后管理-退款申请单-退款确认单待退款明细'
    },
    component: RefundApplicationOrderList
  }

];
